import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-722a9b46"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navigation-footer" }

import { Icons } from '@/enums/Icons';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import BaseButton from '@/components/BaseButton.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'NavigationFooter',
  props: {
    isFirst: { type: Boolean },
    isLast: { type: Boolean }
  },
  emits: ['requestNextStep', 'requestPreviousStep'],
  setup(__props: any) {

const { t } = useI18n();



const props = __props;

const nextButtonLabel = computed(() => {
  return props.isLast ? t('wizard.submit') : t('wizard.next');
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isFirst)
      ? (_openBlock(), _createBlock(BaseButton, {
          key: 0,
          rounded: "",
          color: "medium",
          class: "navigation-footer__button",
          icon: _unref(Icons).BackArrow,
          "icon-slot": "start",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('requestPreviousStep')))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('wizard.previous')), 1)
          ]),
          _: 1
        }, 8, ["icon"]))
      : _createCommentVNode("", true),
    _createVNode(BaseButton, {
      rounded: "",
      class: "navigation-footer__button",
      icon: _unref(Icons).NextArrow,
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('requestNextStep')))
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(nextButtonLabel.value), 1)
      ]),
      _: 1
    }, 8, ["icon"])
  ]))
}
}

})